var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { omit } from "lodash";
import id from "@irati/utils/id";
import Text from "./Text";
import { Icon, TextHelper } from "./styled";
var IconText = function (props) {
    var idNamespace = id("icon-text", props);
    var componentProps = omit(props, ["id"]);
    var iconElement = (React.createElement("div", null,
        React.createElement(Icon, __assign({ icon: "info" }, componentProps, { id: id("icon", idNamespace) }))));
    var isRightSidedIcon = props.iconPosition === "right";
    return (React.createElement(TextHelper, __assign({}, componentProps, { id: idNamespace }),
        !isRightSidedIcon && iconElement,
        React.createElement(Text, null, props.children),
        isRightSidedIcon && iconElement));
};
IconText.defaultProps = {
    size: "16",
    iconPosition: "left",
    values: {}
};
export default IconText;
